<script>
  import { resolveStatusClass } from '@utils/status'

  export default {
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {
        type: null,
        required: true,
      },
      getStatuses: {
        type: null,
        default: null,
      },
      getChangeableStatuses: {
        type: Function,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        finishedLoading: false,
        status: this.value,
        statuses: [],
      }
    },
    computed: {
      changeableStatuses() {
        return this.getChangeableStatuses !== null
          ? this.getChangeableStatuses(this.statuses)
          : this.statuses
      }
    },
    watch: {
      status (val) {
        this.$emit('change', val)
      },
      value () {
        this.status = this.value
      },
    },
    async created() {
      await this.loadStatuses()
      this.finishedLoading = true
    },
    methods: {
      resolveStatusClass,
      async loadStatuses () {
        switch(typeof this.getStatuses) {
          case 'function':{
            // load async
            const { data } = await this.getStatuses()
            this.statuses = data
            break;
          }
          case 'object':{
            // load from formatted data
            this.statuses = this.getStatuses
            break;
          }
          default:
            break;
        }
      },
      tryToChangeStatus (val) {
        this.status = val
      },
    }
  };
</script>
<template>
  <FabricDropdown
    :disabled="disabled || !finishedLoading"
    right
    toggle-class="btn-dropdown">
    <template v-slot:button-content>
      <span
        :class="[
          'status-item',
          'text-capitalize',
          resolveStatusClass(status && status.key ? status.key.toLowerCase() : ''),
        ]">{{ status.name }}</span>
    </template>
    <FabricDropdownElement
      v-for="item in changeableStatuses"
      :key="item.key"
      class="item"
      type="link"
      element-classes="tw-no-underline"
      :value="item.key"
      @click="tryToChangeStatus(item)">
      <span
        :class="[
          'status-item',
          resolveStatusClass(item.key.toLowerCase()),
        ]">{{ item.name }}</span>
    </FabricDropdownElement>
  </FabricDropdown>
</template>
